import React, { useEffect, useState, useRef, useContext } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import $ from 'jquery';
import { CheckSession, FormatCurrency, GetCoockie, GetShoppingCart, KImageURL, DefaultImage } from "../GlobalScript";
import Cookies from 'js-cookie';
import Select from 'react-select';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Table from 'react-bootstrap/Table';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import InputGroup from 'react-bootstrap/InputGroup';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { EditorState, convertToRaw, convertFromRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import FooterDealer from '../FooterDealer';

export default function ItemEdit() {

    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [itemNumber, setItemNumber] = useState('');
    const [formattedItemNumber, setFormattedItemNumber] = useState('');
    const [itemName, setItemName] = useState('');
    const [itemShortDescription, setItemShortDescription] = useState('');
    const [itemExtendedDescription, setItemExtendedDescription] = useState('');
    const [status, setStatus] = useState(false);
    const [latinInclude, setLatinInclude] = useState(false);
    const [dealerInclude, setDealerInclude] = useState(false);
    const [estoreInclude, setEstoreInclude] = useState(false);
    const [category, setCategory] = useState(null);
    const [categoryList, setCategoryList] = useState(null);
    const [relatedItem, setRelatedItem] = useState(null);
    const [model, setModel] = useState(null);
    const [year, setYear] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [attachmentType, setAttachmentType] = useState('');
    const [dealerPrice, setDealerPrice] = useState('');
    const [msrp, setMsrp] = useState('');
    const [shortEditorState, setShortEditorState] = useState(EditorState.createEmpty());
    const [extendedEditorState, setExtendedEditorState] = useState(EditorState.createEmpty());
    const [showDetailsModal, setShowDetailsModal] = useState(false);

    useEffect(() => {
        document.title = 'K-Dealer - Item Edit';
    });

    useEffect(() => {
        if (!location.state || !location.state.id) {
            navigate('/inventorylist');
            return;
        }
        GetOrderDetail(location.state.id);
        LoadCategoryList();
    }, [location])

    const navigateBack = () => {
        navigate('/inventorylist');
    }

    //Leave modal code just in case we add one later to this page
    const handleDetailsModalShow = () => {
        setShowDetailsModal(true);
    }
    const handleDetailsModalClose = () => {
        setShowDetailsModal(false);
    }

    const GetOrderDetail = async (id) => {
        CheckSession();
        const response = await fetch("inventory/GetItemDetail/" + id);
        if (response.status !== 200) {
            return;
        }
        const res = await response.json();
        console.log(res);
        setItemNumber(res.itemNumber);
        setFormattedItemNumber(res.formattedItemNumber);
        setItemShortDescription(res.descr);
        setItemExtendedDescription(res.extendedDescr);
        setItemName(res.itemName);
        setLatinInclude(res.la);
        setCategory(res.category);
        setStatus(res.status);
        setDealerInclude(res.kDealer);
        setEstoreInclude(res.eStore);

        //Below is the code to convert plain text into usable text for the editors.
        //Once it is saved in a raw format(not plain text, with formatting), we will
        //need to convert it to raw content.
        const contentStateShort = ContentState.createFromText(res.descr);
        setShortEditorState(EditorState.createWithContent(contentStateShort));
        setItemShortDescription(res.descr);

        const contentStateExtended = ContentState.createFromText(res.extendedDescr);
        setExtendedEditorState(EditorState.createWithContent(contentStateExtended));
        setItemExtendedDescription(res.extendedDescr);

        //example:
        //const contentStateShort = convertFromRaw(res.descr);
        //setShortEditorState(EditorState.createWithContent(contentStateShort));
        //setItemShortDescription(res.descr);
    }

    const LoadCategoryList = async () => {
        try {
            CheckSession();
            const response = await fetch("inventory/GetCategoryList");
            if (response.status !== 200) {
                return;
            }
            const lst = await response.json();
            setCategoryList(lst);
        }
        catch (e) {
            console.log(e);
            return;
        }
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name === 'itemNumber') {
            setItemNumber(value);
        } else if (name === 'formattedItemNumber') {
            setFormattedItemNumber(value);
        } else if (name === 'itemName') {
            setItemName(value);
        } else if (name === 'shortDescription') {
            setItemShortDescription(value);
        } else if (name === 'extendedDescription') {
            setItemExtendedDescription(value);
        } else if (name === 'status') {
            setStatus(value === 'true');
        } else if (name === 'latinInclude') {
            setLatinInclude(event.target.checked);
        } else if (name === 'dealerInclude') {
            setDealerInclude(event.target.checked);
        } else if (name === 'eStoreInclude') {
            setEstoreInclude(event.target.checked);
        } else if (name === 'attachmentType') {
            setAttachmentType(value);
        } else if (name === 'dealerPrice') {
            setDealerPrice(value);
        } else if (name === 'msrp') {
            setMsrp(value);
        }
    }

    const handleShortEditorChange = (state) => {
        setShortEditorState(state);
        const rawContent = convertToRaw(state.getCurrentContent());
        const plainText = state.getCurrentContent().getPlainText();
        setItemShortDescription(rawContent);
    };

    const handleExtendedEditorChange = (state) => {
        setExtendedEditorState(state);
        const rawContent = convertToRaw(state.getCurrentContent());
        const plainText = state.getCurrentContent().getPlainText();
        setItemExtendedDescription(rawContent);
    };

    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    const handleChangeCategory = (selected) => {
        setCategory(selected);
    };

    const handleChangeRelatedItem = (selected) => {
        setRelatedItem(selected);
    };

    const handleChangeModel = (selected) => {
        setModel(selected);
    };

    const handleChangeYear = (selected) => {
        setYear(selected);
    };

    const handleSubmit = () => {
        SubmitItem();
    }

    const SubmitItem = async () => {
        CheckSession();
        if (!category || category.length == 0) {
            return;
        }
        const data = {
            itemNumber: itemNumber,
            formattedItemNumber: formattedItemNumber,
            itemName: itemName,
            descr: itemShortDescription,
            extendedDescr: itemExtendedDescription,
            status: status,
            kDealer: dealerInclude,
            LA: latinInclude,
            eStore: estoreInclude,
            category: category,
            userID: 0
        }
        
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-type': 'application/json'
            },
            body: JSON.stringify(data)
        };
        const response = await fetch("inventory/SubmitItem", requestOptions);
        if (response.status !== 200) {
            return;
        }
    }

    return (
        <>
            <Container className="checkout-container main-container dealer-section min-height-spacing-lg">

                <Row className="help-title-row checkout-title-row">
                    <Col className="help-center-title checkout-title">
                        <h1 className="heading help-heading">Item Edit</h1>
                    </Col>
                    <Col className="checkout-title-under text-right">
                        <p><span className="underline bold" onClick={navigateBack}>&lt;&lt; Back</span></p>
                    </Col>
                </Row>

                <Row className="mb-5 g-0 tab-row">
                    <Col sm={8} className="tab-left-green">
                        <Card>
                            <Card.Body>
                                <Row>
                                    <Col sm={12}>
                                        <Row>
                                            <Col sm={12}>
                                                <h3 className="bold heading">ITEM INFORMATION</h3>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col sm={3}>
                                                <FloatingLabel label="Item Number" className="mb-4">
                                                    <Form.Control type="text" placeholder="Item Number" value={itemNumber} className={'form-control'} onChange={handleChange} name="itemNumber" disabled={true} />
                                                </FloatingLabel>
                                            </Col>
                                            <Col sm={3}>
                                                <FloatingLabel label="Formatted Item Number" className="mb-4">
                                                    <Form.Control type="text" placeholder="Formatted Item Number" value={formattedItemNumber} className={'form-control'} onChange={handleChange} name="formattedItemNumber" />
                                                </FloatingLabel>
                                            </Col>
                                            <Col sm={6}>
                                                <FloatingLabel label="Item Name" className="mb-4">
                                                    <Form.Control type="text" placeholder="Item Name" value={itemName} className={'form-control'} onChange={handleChange} name="itemName" />
                                                </FloatingLabel>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col sm={6}>
                                                <div className="mb-4 text-area-tall">
                                                    <Editor
                                                        editorClassName="editor-custom"
                                                        wrapperClassName="wrapper-custom"
                                                        toolbarClassName="toolbar-custom"
                                                        placeholder="Item Short Description"
                                                        editorState={shortEditorState}
                                                        onEditorStateChange={handleShortEditorChange}
                                                        toolbar={{
                                                            options: ['inline', 'list', 'textAlign'],
                                                            inline: {
                                                                options: ['bold', 'italic', 'underline'],
                                                            },
                                                            list: {
                                                                options: ['unordered', 'ordered'],
                                                            },
                                                            textAlign: {
                                                                options: ['left', 'center', 'right'],
                                                            },
                                                        }}
                                                    />
                                                </div>
                                                {/*<FloatingLabel label="Item Short Description">*/}
                                                {/*    <Form.Control*/}
                                                {/*        as="textarea"*/}
                                                {/*        name="shortDescription"*/}
                                                {/*        value={itemShortDescription}*/}
                                                {/*        placeholder="Item Short Description"*/}
                                                {/*        maxLength="200"*/}
                                                {/*        onChange={handleChange}*/}
                                                {/*        className="mb-4 border-black text-area-tall"*/}
                                                {/*    />*/}
                                                {/*</FloatingLabel>*/}
                                            </Col>
                                            <Col sm={6}>
                                                <div className="mb-4 text-area-tall">
                                                    <Editor
                                                        editorClassName="editor-custom"
                                                        wrapperClassName="wrapper-custom"
                                                        toolbarClassName="toolbar-custom"
                                                        placeholder="Item Extended Description"
                                                        editorState={extendedEditorState}
                                                        onEditorStateChange={handleExtendedEditorChange}
                                                        toolbar={{
                                                            options: ['inline', 'list', 'textAlign'],
                                                            inline: {
                                                                options: ['bold', 'italic', 'underline'],
                                                            },
                                                            list: {
                                                                options: ['unordered', 'ordered'],
                                                            },
                                                            textAlign: {
                                                                options: ['left', 'center', 'right'],
                                                            },
                                                        }}
                                                    />
                                                </div>
                                                {/*<FloatingLabel label="Item Extended Description">*/}
                                                {/*    <Form.Control*/}
                                                {/*        as="textarea"*/}
                                                {/*        name="extendedDescription"*/}
                                                {/*        value={itemExtendedDescription}*/}
                                                {/*        placeholder="Item Extended Description"*/}
                                                {/*        maxLength="1000"*/}
                                                {/*        onChange={handleChange}*/}
                                                {/*        className="mb-4 border-black text-area-tall"*/}
                                                {/*    />*/}
                                                {/*</FloatingLabel>*/}
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col sm={6}>
                                                <Form.Select aria-label="Credit Request Reasons" value={status} onChange={handleChange} name="status" className="mb-4">
                                                    <option value={''}>Select an item status</option>
                                                    <option value={'true'}>Active</option>
                                                    <option value={'false'}>Inactive</option>
                                                </Form.Select>
                                            </Col>
                                            <Col sm={6}>
                                                <Form.Check type="checkbox" name="latinInclude" aria-label='Include in Latin America'
                                                    checked={latinInclude} onChange={handleChange} className="mb-4 mt-2" label='Include in Latin America' />
                                            </Col>
                                            <Col sm={6}>
                                                <Form.Check type="checkbox" name="dealerInclude" aria-label='Include in K-Dealer'
                                                    checked={dealerInclude} onChange={handleChange} className="mb-4 mt-2" label='Include in K-Dealer' />
                                            </Col>
                                            <Col sm={6}>
                                                <Form.Check type="checkbox" name="eStoreInclude" aria-label='Include in eStore'
                                                    checked={estoreInclude} onChange={handleChange} className="mb-4 mt-2" label='Include in eStore' />
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col sm={4}>
                        <Card className="h-100">
                            <Card.Body>
                                <Row>
                                    <Col sm={12}>
                                        <Row>
                                            <Col sm={12}>
                                                <h3 className="bold heading">CATEGORY</h3>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col sm={12}>
                                                {categoryList && categoryList.length > 0 &&
                                                    <Select
                                                        placeholder={<div>Category</div>}
                                                        isMulti
                                                        options={categoryList}
                                                        value={category}
                                                        onChange={handleChangeCategory}
                                                        className="mt-2"
                                                    />
                                                }
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mb-5 g-0 tab-row">
                    <Col sm={8}>
                        <Row>
                            <Col sm={12}>
                                <Card className="tab-left-green mb-4">
                                    <Card.Body>
                                        <Row>
                                            <Col sm={12}>
                                                <Row>
                                                    <Col sm={12}>
                                                        <h3 className="bold heading">SUBSKU</h3>
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col sm={9}>
                                                        <Table hover responsive>
                                                            <thead>
                                                                <tr>
                                                                    <th>#</th>
                                                                    <th>STYLE</th>
                                                                    <th>COLOR</th>
                                                                    <th>SIZE</th>
                                                                </tr>
                                                            </thead>
                                                        </Table>
                                                    </Col>

                                                    <Col sm={3} className="text-right">
                                                        <Button variant="primary">
                                                            + ADD SUBSKU
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col sm={12}>
                                <Card className="tab-left-green mb-4">
                                    <Card.Body>
                                        <Row>
                                            <Col sm={12}>
                                                <Row>
                                                    <Col sm={12}>
                                                        <h3 className="bold heading">IMAGES</h3>
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col sm={9}>
                                                        <Table hover responsive>
                                                            <thead>
                                                                <tr>
                                                                    <th>#</th>
                                                                    <th>STYLE</th>
                                                                    <th>COLOR</th>
                                                                    <th>VARIATIONS</th>
                                                                </tr>
                                                            </thead>
                                                        </Table>
                                                    </Col>

                                                    <Col sm={3} className="text-right">
                                                        <Button variant="primary">
                                                            + ADD IMAGE
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col sm={12}>
                                <Card className="tab-left-green">
                                    <Card.Body>
                                        <Row>
                                            <Col sm={12}>
                                                <Row>
                                                    <Col sm={12}>
                                                        <h3 className="bold heading">ATTACHMENTS</h3>
                                                    </Col>
                                                </Row>

                                                <Row className="mt-3">
                                                    <Col sm={3}>
                                                        <p>Attachment Upload</p>
                                                    </Col>
                                                    <Col sm={9}>
                                                        <input type="file" onChange={handleFileChange} />
                                                    </Col>
                                                </Row>

                                                <Row className="mt-3">
                                                    <Col sm={3}>
                                                        <p>Attachment Type</p>
                                                    </Col>
                                                    <Col sm={6}>
                                                        <Form.Select aria-label="Vehicle" value={attachmentType} onChange={handleChange} name="attachmentType">
                                                            <option value={''}>Select an attachment type</option>
                                                            <option value={'1'}>Installation Instructions</option>
                                                        </Form.Select>
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col sm={12} className="text-right">
                                                        <Button variant="primary">
                                                            + ADD ATTACHMENT
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Col>

                    <Col sm={4}>
                        <Card className="h-100">
                            <Card.Body>
                                <Row>
                                    <Col sm={12}>
                                        <Row>
                                            <Col sm={12}>
                                                <h3 className="bold heading">RELATED ITEMS</h3>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col sm={12}>
                                                {categoryList && categoryList.length > 0 &&
                                                    <Select
                                                        placeholder={<div>Item ID</div>}
                                                        isMulti
                                                        options={categoryList}
                                                        value={relatedItem}
                                                        onChange={handleChangeRelatedItem}
                                                        className="mt-2"
                                                    />
                                                }
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mb-3 g-0 tab-row">
                    <Col sm={7} className="tab-left-green">
                        <Card className="h-100">
                            <Card.Body>
                                <Row>
                                    <Col sm={12}>
                                        <Row>
                                            <Col sm={12}>
                                                <h3 className="bold heading">COMPATIBLE MODELS</h3>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col sm={6}>
                                                {categoryList && categoryList.length > 0 &&
                                                    <Select
                                                        placeholder={<div>Model</div>}
                                                        isMulti
                                                        options={categoryList}
                                                        value={model}
                                                        onChange={handleChangeModel}
                                                        className="mt-2"
                                                    />
                                                }
                                            </Col>
                                            <Col sm={6}>
                                                {categoryList && categoryList.length > 0 &&
                                                    <Select
                                                        placeholder={<div>Year</div>}
                                                        isMulti
                                                        options={categoryList}
                                                        value={year}
                                                        onChange={handleChangeYear}
                                                        className="mt-2"
                                                    />
                                                }
                                            </Col>
                                        </Row>                                        
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col sm={5}>
                        <Card className="h-100">
                            <Card.Body>
                                <Row>
                                    <Col sm={12}>
                                        <Row>
                                            <Col sm={12}>
                                                <h3 className="bold heading">PRICING</h3>
                                            </Col>
                                        </Row>

                                        <Row className="mt-3">
                                            <Col sm={4}>
                                                <p className="mt-3">Dealer Price</p>
                                            </Col>
                                            <Col sm={8}>
                                                <FloatingLabel label="$">
                                                    <Form.Control type="number" placeholder="$" value={dealerPrice} className={'form-control'} onChange={handleChange} name="dealerPrice" />
                                                </FloatingLabel>
                                            </Col>
                                        </Row>

                                        <Row className="mt-3">
                                            <Col sm={4}>
                                                <p className="mt-3">MSRP</p>
                                            </Col>
                                            <Col sm={8}>
                                                <FloatingLabel label="$">
                                                    <Form.Control type="number" placeholder="$" value={msrp} className={'form-control'} onChange={handleChange} name="msrp" />
                                                </FloatingLabel>
                                            </Col>
                                        </Row>

                                        <Row className="mt-3">
                                            <Col sm={12} className="text-right">
                                                <p>
                                                    <span className="underline">+ Add Alternative Price</span>
                                                </p>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mt-2 mb-5">
                    <Col sm={12} className="text-right">
                        <Button variant="secondary" onClick={handleSubmit}>
                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                            </svg>
                            SAVE
                        </Button>
                    </Col>
                </Row>

            </Container>

            <FooterDealer />           
        </>
    );
}